module.exports = __webpack_public_path__ + "img/logo.34e25d17.svg";